import { REFERRAL_CODE } from "constants/storageKeys";

export const readReferralCode = (): string | null => {
  try {
    const stored = localStorage.getItem(REFERRAL_CODE);
    if (!stored) return null;

    const code = JSON.parse(stored);
    return typeof code === "string" && code ? code : null;
  } catch {
    return null;
  }
};
